import { ColorEnum } from '@/constants/color'
import HeaderNotification from '@/features/notifications/components/HeaderNotification/Component'
import TitleAndBadge from '@/features/notifications/components/HeaderNotification/parts/TitleAndBadge'
import Notification from '@/features/notifications/components/Notification'
import { FC } from 'react'
import PotIcon from 'src/features/notifications/components/icons/PotIcon'

interface PostponedOrderProps {
    title: string
    orderShortCode: string
    description: string
    onPress?: () => void
    onClose: () => void
}

const PostponedOrder: FC<PostponedOrderProps> = ({
    title,
    orderShortCode,
    description,
    onPress,
    onClose,
}) => {
    return (
        <HeaderNotification
            Icon={PotIcon}
            iconContainerColor={ColorEnum.EMERALD_200}
            Title={<TitleAndBadge title={title} badge={orderShortCode} />}
            Description={<Notification.Description>{description}</Notification.Description>}
            onPress={onPress}
            onClose={onClose}
        />
    )
}

export default PostponedOrder
